<template>
  <div
    v-loading="loading"
    class="layout-default"
    element-loading-text="拼命加载中"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <common-header></common-header>
    <body class="body-container">
      <side-nav></side-nav>
      <router-view style="flex: 1; border: 0px solid #666"></router-view>
      <right-panel></right-panel>
    </body>
    <modal-layer></modal-layer>
    <mask-layer></mask-layer>
    <popup-content></popup-content>
    <login-modal
      :value="loginVisible"
      @goto="goTo"
    ></login-modal>
    <register-modal
      :value="registerVisible"
      @goto="goTo"
    ></register-modal>
    <find-pwd
      :value="findPwdVisible"
      @goto="goTo"
    ></find-pwd>
    <guidance></guidance>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import CheckMultiLogin from '@/mixins/checkMultiLogin.vue';

export default {
  name: 'DefaultLayout',
  components: {
    CommonHeader: () => import('@/components/header/index.vue'),
    SideNav: () => import('@/components/sideNav/index.vue'),
    RightPanel: () => import('@/components/rightPanel/index.vue'),
    ModalLayer: () => import('@/components/modal/modalLayer.vue'),
    MaskLayer: () => import('@/components/mask/maskLayer.vue'),
    PopupContent: () => import('@/components/popups/popupContent.vue'),
    LoginModal: () => import('@/components/user/login'),
    RegisterModal: () => import('@/components/user/register'),
    FindPwd: () => import('@/components/user/findPwd'),
    Guidance: () => import('@/components/guidance/guidance')
  },
  mixins: [CheckMultiLogin],
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters(['registerVisible', 'findPwdVisible', 'userInfo', 'vipType', 'loginStatus']),
    ...mapGetters({
      completed: 'completed/getFiles',
      loginVisible: 'loginVisible',
      watermark: 'common/watermark',
      views: 'views/dict',
      videoUrl: 'uploader/videoUrl'
    })
  },
  watch: {
    userInfo() {
      this.$sensors.registerPage({
        platform_type: 'web',
        vip_type: this.vipType,
        is_login: this.loginStatus
      });
      if (this.$route.path === '/') {
        this.unWatch = this.$watch('$route.path', this.handleVisit);
      } else {
        this.handleVisit(this.$route.path);
      }
    },
    videoUrl() {
      if (this.$route.query && this.$route.query.id) {
        this.$router.replace({ query: {} });
      }
    }
  },
  mounted() {
    this.readLocalStorage();
    this.handleVideoQuery();
    // if (this.$route.path === '/') {
    //   this.unWatch = this.$watch('$route.path', this.handleVisit);
    // } else {
    //   this.handleVisit(this.$route.path);
    // }
  },
  created() {
    this.fetchUserInfo();
    window.onbeforeunload = this.onbeforeunload;
    this.$router.beforeEach((to, from, next) => {
      let sourceFallback = '未知';
      let toName = to.path.slice(1);
      toName = (this.views[toName] || {}).text;
      let fromName = from.path.slice(1);
      fromName = (this.views[fromName] || {}).text || sourceFallback;
      if (to.query.pipe == 1) {
        // check duration
        let files = this.$store.getters['completed/getPipeFiles'] || [];
        if (files[0] && files[0].duration && files[0].duration > 3600) {
          this.$message({
            message: '视频时长超过60分钟，无法使用该工具哦。',
            type: 'error'
          });
          return;
        }
        if (files[0] && files[0].duration && files[0].size > 200 * 1024 * 1024) {
          this.$message({
            message: '视频大于200M无法进行继续编辑，请下载保存',
            type: 'error'
          });
          return;
        }
        files[0] && files[0].url && this.$store.commit('uploader/setVideoUrl', files[0].url);
        console.log('turbo: created -> files[0]', files[0]);
        this.$modal.hide('completeModal');
        this.$store.commit('completed/setFiles', []);
        if (files.length) {
          this.$store.commit('common/setEditing', false);
        }
        this.$sensors.track('toolVisit', {
          tool_type: toName || '',
          source: fromName
        });
        // this.handleVideoQuery_();
        next();
        return;
      }

      let _files = this.$store.getters['completed/getFiles'] || [];
      let editing = this.$store.getters['common/editing'];
      if (!window.localStorage.getItem('switch_page_clear_tip') && to.path != from.path && (_files.length || editing)) {
        // let content = '切换工具将会清空当前工具操作，是否确认切换？';
        // let hasQuery = Object.keys(to.query || {}).length;
        // if (!hasQuery) {
        //   content = '是否确认切换？';
        // }
        this.$modal.show('MessageDialog', {
          content: '切换工具将会清空当前工具操作，是否确认切换？',
          btns: ['Cancel', { type: 'Switch', content: '切换' }, 'Close'],
          remind: '之后不再提醒',
          resultHandler: function(value) {
            if (!value) return;
            if (value.type == 'Switch') {
              this.$store.commit('completed/setFiles', []);
              this.$store.commit('completed/setPipeFiles', []);
              this.$store.commit('common/setEditing', false);
              this.$sensors.track('toolVisit', {
                tool_type: toName || '',
                source: fromName
              });
              next();
            }
            if (value.noRemind) {
              window.localStorage.setItem('switch_page_clear_tip', 'hide');
            }
          }
        });
      } else {
        let isSamePath = to.path === from.path;
        let deletingPipe = from.query.pipe && !to.query.pipe;
        console.log('turbo: created -> deletingPipe', deletingPipe);
        if (!deletingPipe && !isSamePath) {
          this.$store.commit('completed/setFiles', []);
          this.$store.commit('completed/setPipeFiles', []);
        }
        this.$store.commit('common/setEditing', false);
        this.$sensors.track('toolVisit', {
          tool_type: toName || '',
          source: fromName
        });
        next();
      }
    });
    this.$router.afterEach((to, from) => {
      if (to.path === from.path /* && to.query.id && !from.query.id */) {
        return;
      }
      this.handleVideoQuery();
    });

    this.$bus.on('checkLogin', this.checkMultiLogin);
    this.$bc.onmessage = async (ev) => {
      console.warn('turbo: this.$bc.onmessage -> ev', ev);
      let checkResult = await this.checkMultiLogin();
      this.$store.commit('changeLoginVisible', !!(checkResult && checkResult.type));
    };
  },
  beforeMount() {
    this.checkThirdParty();
  },
  methods: {
    handleVisit(val) {
      this.unWatch && this.unWatch();
      this.unWatch = null;
      if (val && val.length > 1) {
        // let query = {...this.$route.query};
        // delete query.source;
        // location.search = this.$.query2Search(query);
        let source = this.$.storage.get('sensorWebToolkitViewSource');
        this.$.storage.set('sensorWebToolkitViewSource', '');
        let { fileType } = this.$route.query || {};
        if (fileType == '26') {
          source = '我的素材';
        } else if (fileType == '27') {
          source = '我的作品';
        }
        let rName = this.$route.path.slice(1);
        let text = this.views[rName].text;
        this.$sensors.track('toolVisit', {
          tool_type: text,
          source: source || '未知'
        });
      }
    },
    ...mapMutations(['saveRouteParam']),
    ...mapActions({
      fetchUserInfo: 'fetchUserInfo'
    }),
    onbeforeunload(e) {
      (e || window.event).returnValue = '离开页面将会清空当前工具操作，是否确认切换？';
    },
    goTo(str) {
      let name = 'change' + str[0].toUpperCase() + str.slice(1) + 'Visible';
      this.$store.commit(name, true);
    },

    /**
     * 检查是否为第三方推广链接并保存参数
     * paramStr格式：xx=1&xx=2&xxx=3
     */
    checkThirdParty() {
      // 如果已存在记录（未过期），则不做处理
      if (this.$.storage.get('utmParam')) return;

      let query = this.$route.query;
      let paramStr = this.$route.fullPath.split('?')[1];
      if (!paramStr) return;
      for (let i = 0; i < Object.keys(query).length; i++) {
        if (['utm_source', 'utm_medium', 'utm_campaign'].indexOf(Object.keys(query)[i]) != -1) {
          // 存入vuex
          this.saveRouteParam(paramStr);
          // 存入本地缓存,有效期为七天
          this.$.storage.set('utmParam', paramStr, 7 * 24 * 60 * 60);
          return;
        }
      }
      this.saveRouteParam(paramStr);
    },

    readLocalStorage() {
      this.watermark.clearWatermark = window.localStorage.getItem('watermark-switch') ? true : false;
    },

    handleVideoQuery() {
      let hasUseToolkit = localStorage.getItem('hasUseToolkit');
      if (hasUseToolkit) {
        this.handleVideoQuery_();
      } else {
        this.$bus.on('hasUseToolkit', this.handleVideoQuery_);
      }
    },

    async handleVideoQuery_() {
      let { id: videoId, fileType, pipe } = this.$route.query || {};
      if (videoId == 'undefined') {
        videoId = void 0;
      }
      if (videoId && pipe != '1') {
        const resp = await this.$http.get('/user/video', {
          params: {
            id: videoId,
            fileType
          }
        });
        const info = resp.data.data;
        if (info) {
          this.$bus.emit('changeFiles', {
            name: info.title,
            url: info.url,
            cover: info.cover || info.screen || info.thumbnailUrl,
            duration: info.duration || info.during,
            size: info.size,
            fileType: info.fileType
          });
        }
      }
      if (!videoId) {
        let url = this.$store.getters['uploader/videoUrl'];
        let shot = this.$store.getters['uploader/videoUrlShot'];
        let info = {};
        let cover = '';
        if (shot.url) {
          info = shot;
        } else {
          console.log('turbo: url', url);
          if (!url || typeof url != 'string') {
            return;
          }
          this.loading = true;
          info = await this.$http.get(`/common/material/avinfo?key=${url}`);
          info = info.data.format;
          cover = await this.$.getVideoThumbnail(this.$.handleAssetsUrl(url));
          cover = cover.data.data.filename;
          info.cover = cover;
          this.$store.commit('uploader/setVideoUrlShot', {
            name: url.replace(/\.[^.]+?$/, ''),
            cover: info.cover,
            duration: info.duration,
            size: info.size,
            fileType: 26,
            url: url
          });
        }
        let payload = {
          name: url.replace(/\.[^.]+?$/, ''),
          cover: info.cover,
          duration: info.duration,
          size: info.size,
          fileType: 26,
          url: url
        };
        this.$store.commit('uploader/setVideoUrlShot', payload);
        url && !pipe && this.$bus.emit('changeFiles', payload);
        console.log('turbo: payload', payload);
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.layout-default {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
}

.body-container {
  flex: 1;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}
</style>
